export default "https://cdn-static.gokick.com/assets/bd7d2df9c3fbba7be4a416b625ad3f88793f3763/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";